import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
import { DatePickerInputWUT } from "./date-picker-input/date-picker-input-wut.js";
const DatePickerFieldWUT = ({
  fieldType,
  id,
  target,
  label,
  hideLabel,
  placeholder,
  required,
  description,
  value,
  onChange,
  onFocus,
  onBlur,
  hasError = false,
  errorMessage,
  error,
  validation,
  FieldLayout,
  firstDayOfWeek,
  availability,
  disabled,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          htmlFor: inputId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        DatePickerInputWUT,
        {
          fieldType,
          inputId,
          ariaDescribedBy,
          label,
          placeholder,
          required,
          value,
          onChange,
          onBlur,
          onFocus,
          hasError,
          validation,
          firstDayOfWeek,
          availability,
          disabled,
          fieldId: id
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  DatePickerFieldWUT
};
//# sourceMappingURL=date-picker-field-wut.js.map
